import { render, staticRenderFns } from "./EmailDetailFilter.vue?vue&type=template&id=70c244f2&"
import script from "./EmailDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./EmailDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports